import { Tooltip } from '@fluentui/react-components'
import ActionButton from './ActionButton'

interface SaveButtonProps {
  text: string
  handleOnSaveClick: () => void
  disabled: boolean
  tooltip: string
}

const SaveButton = ({
  text,
  handleOnSaveClick,
  disabled,
  tooltip,
}: SaveButtonProps) => {
  const saveButton = (disabled?: boolean) => (
    <ActionButton
      text={text}
      handleOnClick={handleOnSaveClick}
      buttonStyles={['saveButton']}
      disabled={disabled}
    />
  )

  return (
    <>
      {disabled && tooltip ? (
        <Tooltip content={tooltip} relationship="label" positioning="above">
          {saveButton(disabled)}
        </Tooltip>
      ) : (
        saveButton()
      )}
    </>
  )
}

export default SaveButton
